import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// ProtectedRoute now supports permission-based gating.
const ProtectedRoute = ({ children, permissions }) => {
  const { isAuthenticated, canAny, loading } = useAuth();
  const location = useLocation();

  const required = Array.isArray(permissions)
    ? permissions
    : permissions
    ? [permissions]
    : [];

  if (loading) {
    return (
      <div className="w-full py-12 text-center text-gray-500">
        Verificando sesión...
      </div>
    );
  }

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (required.length > 0 && !canAny(required)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
